import React from 'react';

export const ChatError = ({ flag }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <div
        className='alert alert-danger'
        role='alert'
        style={{ width: '500px', marginTop: '20px' }}
      >
        <h4 className='alert-heading'>Error!</h4>
        <p>An error occured, try again.</p>
        <hr />
        <p className='mb-0'>{flag.msg}.</p>
      </div>
    </div>
  );
};
